import { IWaitlistImportItem } from "@nkr/models/recipients";
import { Button, Panel } from "react-bootstrap";
import { TableWrapper } from "./styles";

interface IProps {
    data: IWaitlistImportItem[],
    onImportAnotherFile: () => void
}

const Complete = (props: IProps) => {
    return (
        <>
            <Panel>
                <Panel.Heading>Step 4: Complete</Panel.Heading>
                <Panel.Body>
                    <div style={{ marginBottom: 20 }}>Waitlist import is now complete.  Please review the changes listed below...</div>

                    <TableWrapper condensed bordered tightspacing='1'>
                        <thead>
                            <tr>
                                <th>Row #</th>
                                <th>MRN</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Birth Date</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.data.map(item =>
                                <tr key={'item-' + item.mrn}>
                                    <td>{item.rowNumber}</td>
                                    <td>{item.mrn}</td>
                                    <td>{item.firstName}</td>
                                    <td>{item.lastName}</td>
                                    <td>{item.birthDate}</td>
                                    <td>{item.status}</td>
                                </tr>
                            )}
                        </tbody>
                    </TableWrapper>
                </Panel.Body>
                <Panel.Footer className='text-right'>
                    <Button bsStyle='primary' onClick={props.onImportAnotherFile}>Import Another File</Button>
                </Panel.Footer>
            </Panel>
        </>
    );
}

export default Complete;